var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47113 3.47113C8.76598 3.17629 9.24402 3.17629 9.53887 3.47113L17.5389 11.4711C17.8337 11.766 17.8337 12.244 17.5389 12.5389L9.53887 20.5389C9.24402 20.8337 8.76598 20.8337 8.47113 20.5389C8.17629 20.244 8.17629 19.766 8.47113 19.4711L15.9373 12.005L8.47113 4.53887C8.17629 4.24402 8.17629 3.76598 8.47113 3.47113Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.ada0cf6678282e91d0341e28efe38dd7.svg";
export { ForwardRef as ReactComponent };